import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { SchoolloginService } from "./schoollogin.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegistrationRequest } from 'src/app/Models/registrationrequest.model';

declare var $: any;

@Component({
  selector: 'app-schoollogin',
  templateUrl: './schoollogin.component.html',
  styleUrls: ['./schoollogin.component.css']
})
export class SchoolloginComponent implements OnInit {
  @ViewChild('loginForm') loginForm: NgForm;
  @ViewChild('forgetPasswordForm') forgetPasswordForm: NgForm;
  @ViewChild('RequestStatusForm') RequestStatusForm: NgForm;
  @ViewChild('RegistrationForm') RegistrationForm: NgForm;
  @ViewChild('verifyOTPForm', { static: true }) verifyOTPForm: NgForm;
  @ViewChild('verifyCollegeOTPForm', { static: true }) verifyCollegeOTPForm: NgForm;

  @ViewChild('CollegeInfoForm') CollegeInfoForm: NgForm;
  @ViewChild('EducationInfoForm') EducationInfoForm: NgForm;
  @ViewChild('OtherInfoForm') OtherInfoForm: NgForm;
  @ViewChild('collegeCode', { static: true }) collegeCode: ElementRef;
  responseData: any;
  data: RegistrationRequest;
  boards: any;
  mediums: any;
  institutetypes: any;
  typeOfTrusts: any;
  dropDownData: any;
  offices: any;
  sections: any;
  states: any;
  cities: any;
  types: any;
  locations: any;
  infrastructures: any;
  designations: any;
  hid_trusteeDetailID: any = -1;
  hid_InfrastructureDetailID: any = -1;
  hid_EmployeeDetailID: any = -1;
  TrusteeDetail: Array<any> = [];
  InfrastructureDetail: Array<any> = [];
  EmployeeDetail: Array<any> = [];
  showremark: boolean = false;
  documentList: Array<any> = [];
  fileextension: any;
  doc: any;
  visibleAquireDate: boolean = false;
  visibleAffiliation: boolean = false;
  standardList: Array<any> = [];
  employeetypes: any;
  collegeCodeErrorMsg: any;
  collegemailid: any;
  visibleclgemail: boolean = false;
  clgcode: any;
  verifyclgcode: any;
  verifycollegemailid: any;
  infraname: any;

  constructor(private service: SchoolloginService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) {
  }

  ngOnInit(): void {
    localStorage.clear();

    this.data = new RegistrationRequest();
    this.fillBoard();
    this.fillMediums();
    this.fillInstituteType();
    this.fillOffice();
    this.fillTypeOfTrust();
    this.fillSection();
    this.fillState();
    this.fillSchoolType();
    this.fillSchoolLocation();
    this.fillInfrastructure();
    this.fillEmployeeType();
    this.fillCity(0);
    if (this.rout.snapshot.paramMap.has('ID')) {
      this.data.HashCode = this.rout.snapshot.paramMap.get('ID');
      setTimeout(() => {
        $('#registrationModal').modal('show');
        this.fillRegistrationRequestDetail("");
      }, 1200);
    }
    var dtToday = new Date();
    var month: string = (dtToday.getMonth() + 1).toString();
    var day: string = (dtToday.getDate()).toString();
    var year: string = (dtToday.getFullYear()).toString();
    if (parseInt(month) < 10)
      month = '0' + month.toString();
    if (parseInt(day) < 10)
      day = '0' + day.toString();
    var maxDate = year + '-' + month + '-' + day;
    $('#RegistrationDate').attr('max', maxDate);
    $('#AcquiredDate').attr('max', maxDate);
  }

  fillBoard() {
    const data = {
    };
    this.service.fillBoard(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.boards = this.dropDownData.dropdownlist;
        this.boards.splice(0, 1);
      });
  }

  fillMediums() {
    const data = {
      HashCode: ""
    };
    this.service.fillMedium(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.mediums = this.dropDownData.dropdownlist;
        this.mediums.splice(0, 1);
        // this.data.Medium = 0;
      });
  }

  fillInstituteType() {
    const data = {
    };
    this.service.fillInstituteType(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.institutetypes = this.dropDownData.dropdownlist;
        this.institutetypes.splice(0, 1);
      });
  }

  fillOffice() {
    const data = {
    };
    this.service.fillOffice(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.offices = this.dropDownData.dropdownlist;
        this.data.Office = 0;
      });
  }

  fillTypeOfTrust() {
    const data = {
    };
    this.service.fillTypeOfTrust(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.typeOfTrusts = this.dropDownData.dropdownlist;
        this.data.TypeOfTrust = 0;
      });
  }

  fillSection() {
    const data = {
    };
    this.service.fillSection(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.sections = this.dropDownData.Sectionlist;
        //console.log(this.sections);
        // this.data.Section = 0;
      });
  }

  fillState() {
    const data = {
    };
    this.service.fillState(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.states = this.dropDownData.dropdownlist;
        this.data.State = 12;
        this.fillCity(0);
      });
  }

  fillCity(id) {
    const data = {
      stateID: this.data.State
    };
    this.service.fillCity(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.cities = this.dropDownData.dropdownlist;
        if (this.data.City == 0 || this.data.City == undefined)
          this.data.City = id;
      });
  }

  fillSchoolType() {
    const data = {
    };
    this.service.fillSchoolType(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.types = this.dropDownData.dropdownlist;
        this.data.SchoolType = 0;
      });
  }

  fillInfrastructure() {
    const data = {
    };
    this.service.fillInfrastructure(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.infrastructures = this.dropDownData.dropdownlist;
        this.data.InfrastructureID = 0;
      });
  }

  fillEmployeeType() {
    const data = {
    };
    this.service.fillEmployeeType(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.employeetypes = this.dropDownData.dropdownlist;
        this.data.EmployeeTypeID = 0;
      });
  }

  fillSchoolLocation() {
    const data = {
    };
    this.service.fillSchoolLocation(data)
      .subscribe(data => {
        this.dropDownData = data;
        this.locations = this.dropDownData.dropdownlist;
        this.data.SchoolLocation = 0;
      });
  }

  blockSpecialChar(e) {
    var k;
    document.all ? k = e.keyCode : k = e.which;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k >= 48 && k <= 57) || k == 91 || k == 93 || k == 45 || k == 32 || k == 92 || k == 47);
  }

  displayAquireDate() {
    this.visibleAquireDate = false;
    for (var i = 0; i < this.sections.length; i++) {
      var j = $('#chksection' + i).is(":checked");
      if (j == true && parseInt(this.sections[i]["value"]) > 2) {
        this.visibleAquireDate = true;
      }
    }
  }

  displayAffiliation() {
    var j = $('#chkBoard' + 1).is(":checked");
    if (j) {
      this.visibleAffiliation = true;
    } else {
      this.visibleAffiliation = false;
      this.data.AffiliationNumberAcquireDate = null;
      this.data.AffiliationNumber = null;
    }
  }

  fillStd() {
    this.standardList = [];
    this.documentList = [];
    //var stdlist = this.sections[i]["StandardList"];
    for (var q = 0; q < this.mediums.length; q++) {
      var m = $("#chkmedium" + q).prop("checked");
      if (m) {
        for (var g = 0; g < this.institutetypes.length; g++) {
          var c = $("#chkinstitute" + g).prop("checked");
          var insval = $("#chkinstitute" + g).val();
          if (c) {
            for (var p = 0; p < this.sections.length; p++) {
              var value = $("#chksection" + p).prop("checked");
              if (value) {
                var stdlist = this.sections[p]["StandardList"];
                for (var j = 0; j < stdlist.length; j++) {
                  var newtext = stdlist[j]["shortname"];
                  var mediumtext = this.mediums[q]["text"];
                  var instext = this.institutetypes[g]["text"];
                  if (insval == stdlist[j]["instituteTypeID"]) {
                    this.standardList[this.standardList.length] = { ...stdlist[j] };
                    this.standardList[this.standardList.length - 1]["MediumID"] = this.mediums[q]["value"];
                    this.standardList[this.standardList.length - 1]["medium"] = this.mediums[q]["text"];
                    this.standardList[this.standardList.length - 1]["text"] = newtext + " - " + this.sections[p]["text"] + " - " + mediumtext + " Medium" + " - " + instext;

                    // this.documentList[this.documentList.length] = { ...stdlist[j] };;
                    // this.documentList[this.documentList.length - 1]["ViewURL"] = "assets/images/no-image.jpg";
                    // this.documentList[this.documentList.length - 1]["downloadURL"] = "assets/images/no-image.jpg";
                    // this.documentList[this.documentList.length - 1]["StandardID"] = stdlist[j]["value"];
                    // this.documentList[this.documentList.length - 1]["MediumID"] = this.mediums[q]["value"];
                    // this.documentList[this.documentList.length - 1]["text"] = newtext + " - " + mediumtext + " Medium";
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  manageRegDoc(i, text, mediumID, sectionID, stdID) {
    this.spinner.show();
    var c = $("#chkStd" + i).prop("checked");
    if (c) {
      for (var j = 0; j < this.sections.length; j++) {
        if (this.sections[j]["value"] == sectionID) {
          var stdList = this.sections[j]["StandardList"];
          break;
        }
      }
      for (var j = 0; j < stdList.length; j++) {
        if (stdList[j]["value"] == stdID) {
          this.documentList[this.documentList.length] = stdList[j];
          this.documentList[this.documentList.length - 1]["ViewURL"] = "assets/images/no-image.jpg";
          this.documentList[this.documentList.length - 1]["downloadURL"] = "assets/images/no-image.jpg";
          this.documentList[this.documentList.length - 1]["StandardID"] = stdList[j]["value"];
          this.documentList[this.documentList.length - 1]["text"] = text;
          this.documentList[this.documentList.length - 1]["MediumID"] = mediumID;
          break;
        }
      }
    }
    else {
      for (var j = 0; j < this.documentList.length; j++) {
        if (this.documentList[j]["StandardID"] == stdID && this.documentList[j]["MediumID"] == mediumID) {
          this.documentList.splice(j, 1);
          //break;
        }
      }
    }
    this.spinner.hide();
  }

  uploadImage(event, i) {
    if (event.target.files.length > 0) {
      this.doc = event.target.files[0];
      if (Math.round(this.doc.size / 1024) > 1000) {
        this.toastr.error("File size can't be greater then 1 MB");
        return;
      }
      this.fileextension = this.doc.name.split('.');
      if (this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "jpg" && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "png"
        && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "jpeg" && this.fileextension[this.fileextension.length - 1].toString().toLowerCase() != "pdf") {
        this.toastr.error("You can upload only jpg, jpeg, png or pdf file");
        return;
      }
      if (this.fileextension[this.fileextension.length - 1].toString().toLowerCase() == "pdf") {
        document.getElementById("preview_" + i).setAttribute("src", "assets/images/pdfimage.jpg");
      }
      //else {
      const [file] = event.target.files;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        document.getElementById("preview_" + i).setAttribute("src", reader.result as string);
        if (this.fileextension[this.fileextension.length - 1].toString().toLowerCase() == "pdf") {
          document.getElementById("preview_" + i).setAttribute("src", "assets/images/pdfimage.jpg");
        }
        this.documentList[i]["Document"] = reader.result as string;
        //this.establishmentDetailList[i]["ViewURL"] = reader.result as string;
        this.documentList[i]["Extension"] = "." + this.fileextension[this.fileextension.length - 1].toString().toLowerCase();
        //}
      }
    } else {
      this.doc = "";
      this.documentList[i]["Document"] = "";
      this.documentList[i]["ViewURL"] = "assets/images/no-image.jpg";
      this.documentList[i]["downloadURL"] = "assets/images/no-image.jpg";
      this.documentList[i]["Extension"] = "";
    }
  }

  getEmail() {
    if (this.collegeCode.nativeElement.value) {
      document.getElementById("divCollegeCode").style.display = "none";

      var objCollege = {
        "collegeCode": this.collegeCode.nativeElement.value,
      }
      this.clgcode = this.collegeCode.nativeElement.value;
      this.spinner.show();
      this.service.getRegisterEmailID(objCollege)
        .subscribe((data1: Response) => {
          this.spinner.hide();
          this.responseData = data1;
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
          } else {
            this.toastr.success(this.responseData.message);
            this.collegemailid = this.responseData.EmailID;
            this.visibleclgemail = true;
            this.closeCollege();
            $('#verifyOTPModal').modal('show');
          }
        });
      // this.collegeCode.nativeElement.value = "";
    }
    else {
      if (!this.collegeCode.nativeElement.value) {
        document.getElementById("divCollegeCode").style.display = "block";
        this.collegeCodeErrorMsg = "College code is required";
      }

    }
  }
  sendCollegeOTP() {
    if (this.verifyclgcode == undefined || this.verifyclgcode == "") {
      this.toastr.error("Invalid college code");
      return;
    }
    if (this.verifycollegemailid == undefined || this.verifycollegemailid == "") {
      this.toastr.error("Invalid college emailid");
      return;
    }

    var objCollege = {
      "collegeMailID": this.verifycollegemailid,
      "collegeCode": this.verifyclgcode
    }
    this.spinner.show();
    this.service.collegeSendOTP(objCollege)
      .subscribe((data1: Response) => {
        this.spinner.hide();
        this.responseData = data1;
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
        } else {
          this.toastr.success(this.responseData.message);
          this.closeCollegeVerify();
          $('#verifyCollegeCodeOTPModal').modal('show');
        }
      });
    // this.collegeCode.nativeElement.value = "";

  }
  getCollegeCodeEmail() {
    if (this.data.UDiseNo == null || $.trim(this.data.UDiseNo) == "" || this.data.UDiseNo == undefined) {
      this.toastr.error("College code is required");
      return;
    }
    var objCollege = {
      "collegeCode": this.data.UDiseNo,
    }
    this.verifyclgcode = this.data.UDiseNo;
    this.spinner.show();
    this.service.fillRegistrationDetailByCollegeCode(objCollege)
      .subscribe((data1: Response) => {
        this.spinner.hide();
        this.responseData = data1;
        if (this.responseData.status == false) {
          if (this.data.UDiseNo != undefined && this.data.UDiseNo.toString().trim().length > 0)
            this.toastr.error("Invalid college code");
        } else {
          //this.toastr.success(this.responseData.message);
          this.verifycollegemailid = this.responseData.SchoolMailID;
          $('#collegeCodeOTPModal').modal('show');
        }
      });
    // this.collegeCode.nativeElement.value = "";

  }
  closeCollegeVerify() {
    $('#collegeCodeOTPModal').modal('hide');
  }
  getInfraName() {
    this.infraname = $("#InfrastructureID :selected").text();
    if ($.trim(this.infraname.toLowerCase()) == "other") {
      $("#divotherinfra").css("display", "block");
    }
    else {
      $("#divotherinfra").css("display", "none");
    }
  }

  closeVerify() {
    $('#verifyOTPModal').modal('hide');
    this.verifyOTPForm.resetForm();
  }
  closeCollegeOTPVerify() {
    $('#verifyCollegeCodeOTPModal').modal('hide');
    this.verifyCollegeOTPForm.resetForm();
  }
  closeCollege() {
    $('#collegeModal').modal('hide');
    $("#registrationModal").css({ 'overflow-x': 'hidden', 'overflow-y': 'auto' });
    document.getElementById("divCollegeCode").style.display = "none";
    this.collegeCode.nativeElement.value = "";
  }
  openCollege() {
    $('#collegeModal').modal('show');
  }
  openCollegeCode() {
    $('#collegeCodeOTPModal').modal('show');
  }
  verifyOTP(forgotOTP) {
    if (this.verifyOTPForm.valid) {
      this.spinner.show();
      const data = {
        emailid: this.collegemailid,
        collegecode: this.clgcode,
        otp: forgotOTP,
        otpfor: "ForgotFRC"
      }

      this.service.verifyOTP(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
          }
          else {
            this.closeVerify();
            this.fillRegistrationRequestDetail(this.responseData.HashCode)
          }
        });
    }
  }
  verifyCollegeOTP(forgotOTP) {
    if (this.verifyCollegeOTPForm.valid) {
      this.spinner.show();
      const data = {
        emailid: this.verifycollegemailid,
        collegecode: this.verifyclgcode,
        otp: forgotOTP,
        otpfor: "VerifyCollege"
      }

      this.service.verifyOTP(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
          }
          else {
            this.fillRegistrationDetailByCollegeCode();
            this.closeCollegeOTPVerify();
            $("#registrationModal").css("overflow", "auto");
          }
        });
    }
  }
  fillRegistrationRequestDetail(hsCode) {
    this.spinner.show();
    var Requestdata;
    if (hsCode != "") {
      Requestdata = {
        HashCode: hsCode
      }
    } else {
      Requestdata = {
        HashCode: this.data.HashCode,
      }
    }

    this.service.fillRegistrationRequestDetail(Requestdata)
      .subscribe((data1: Response) => {
        this.spinner.hide();
        this.responseData = data1;
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          //$('#registrationModal').modal('hide');
        } else {
          this.data = this.responseData;
          // this.fillCity();
          for (var i = 0; i < this.boards.length; i++) {
            if (this.data.Board.includes(this.boards[i]["value"])) {
              $('#chkBoard' + i).prop("checked", true);
            }
            if (this.responseData.hasRequest > 0)
              $('#chkBoard' + i).prop("disabled", true);
          }
          for (var i = 0; i < this.mediums.length; i++) {
            if (this.data.Medium.includes(this.mediums[i]["value"])) {
              $('#chkmedium' + i).prop("checked", true);
            }
            if (this.responseData.hasRequest > 0)
              $('#chkmedium' + i).prop("disabled", true);
          }
          for (var i = 0; i < this.institutetypes.length; i++) {
            if (this.data.InstituteTypeID.includes(this.institutetypes[i]["value"])) {
              $('#chkinstitute' + i).prop("checked", true);
            }
            if (this.responseData.hasRequest > 0)
              $('#chkinstitute' + i).prop("disabled", true);
          }
          var f = 0;
          for (var i = 0; i < this.sections.length; i++) {
            if (this.data.Section.includes(this.sections[i]["value"])) {
              $('#chksection' + i).prop("checked", true);
              if (parseInt(this.sections[i]["value"]) > 2) {
                f++;
              }
            }
          }
          //setTimeout(() => {
          this.fillStd();
          //}, 1000);
          this.displayAffiliation();
          if (f > 0) {
            this.visibleAquireDate = true;
          }
          this.TrusteeDetail = this.data.TrusteeDetail;
          this.InfrastructureDetail = this.data.InfrastructureDetail;
          this.EmployeeDetail = this.data.EmployeeDetail;
          this.documentList = this.data.DocumentDetail;

          this.data.EmployeeTypeID = 0;
          this.data.InfrastructureID = 0;

          for (var i = 0; i < this.documentList.length; i++) {
            this.documentList[i]["text"] = this.documentList[i]["Standard"] + " - " + this.documentList[i]["Medium"] + " Medium" + " - " + this.documentList[i]["InstituteType"];
            this.documentList[i]["Document"] = this.documentList[i]["ViewURL"];
            if (this.documentList[i]["Extension"] != ".jpg" && this.documentList[i]["Extension"] != ".jpeg"
              && this.documentList[i]["Extension"] != ".png") {
              this.documentList[i]["downloadURL"] = "assets/images/pdfimage.jpg";
            } else {
              this.documentList[i]["downloadURL"] = this.documentList[i]["ViewURL"];
            }
          }
          setTimeout(() => { this.setStandardOnEdit(); }, 1000);
          // change true to false because of change
          this.showremark = false;
          $("#btnsavepersonal").css("display", "block");
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });

  }

  setStandardOnEdit() {
    var found = 0
    for (var i = 0; i < this.standardList.length; i++) {
      found = 0;
      for (var j = 0; j < this.documentList.length; j++) {
        if (this.standardList[i]["MediumID"] == this.documentList[j]["MediumID"]
          && this.standardList[i]["value"] == this.documentList[j]["StandardID"]) {
          found++;
          $("#chkStd" + i).prop("checked", true);
          break;
        }
      }
      if (found == 0) {
        $("#chkStd" + i).prop("checked", false);
      }
    }
  }

  onSubmit() {
    if (this.loginForm.valid) {
      this.spinner.show();
      var Requestdata = {
        UserName: this.loginForm.value['userName'],
        PWD: this.loginForm.value['password']
      }
      this.service.login(Requestdata)
        .subscribe((data1: Response) => {
          this.spinner.hide();
          this.responseData = data1;
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
          } else {
            localStorage.setItem("token", this.responseData.Token);
            localStorage.setItem("userName", this.loginForm.value['userName']);
            localStorage.setItem("yearID", this.responseData.YearID);
            // localStorage.setItem("userID", this.data.UserID);
            localStorage.setItem("HashCode", this.responseData.HashCode);
            localStorage.setItem("yearName", this.responseData.YearName);
            localStorage.setItem("cd", "$#@!");
            this.router.navigate(['/dashboard']);
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }

  addEmployeeDetail() {
    if (this.data.EmployeeTypeID == undefined || this.data.EmployeeTypeID == 0) {
      this.toastr.error("Select employee category");
      return
    }

    if (this.data.TotalPermanentSalary > 0) {
      if ((this.data.NoOfPermanentEmployee == undefined || this.data.NoOfPermanentEmployee == null || this.data.NoOfPermanentEmployee == 0)) {
        this.toastr.error("Enter no of permanent employees");
        return
      }
    }
    if (this.data.TotalAdhocSalary > 0) {
      if ((this.data.NoOfAdhocEmployee == undefined || this.data.NoOfAdhocEmployee == null || this.data.NoOfAdhocEmployee == 0)) {
        this.toastr.error("Enter no of adhoc employees");
        return
      }
    }

    if (this.data.NoOfPermanentEmployee > 0 && (this.data.TotalPermanentSalary == null || this.data.TotalPermanentSalary == 0)) {
      this.toastr.error("Enter total salary of permanent employees");
      return
    }

    if (this.data.NoOfAdhocEmployee > 0 && (this.data.TotalAdhocSalary == null || this.data.TotalAdhocSalary == 0)) {
      this.toastr.error("Enter total salary of adhoc employees");
      return
    }

    var empType = null
    for (var i = 0; i < this.employeetypes.length; i++) {
      if (this.data.EmployeeTypeID == this.employeetypes[i]["value"]) {
        empType = this.employeetypes[i]["text"];
        break;
      }
    }

    if (parseInt(this.hid_EmployeeDetailID) >= 0) {
      this.EmployeeDetail[this.hid_EmployeeDetailID] = {
        "EmployeeTypeID": this.data.EmployeeTypeID, "EmployeeType": empType, "NoOfPermanentEmployee": this.data.NoOfPermanentEmployee
        , "NoOfAdhocEmployee": this.data.NoOfAdhocEmployee, "TotalPermanentSalary": this.data.TotalPermanentSalary, "TotalAdhocSalary": this.data.TotalAdhocSalary
      }
    }
    else {
      for (var i = 0; i < this.EmployeeDetail.length; i++) {
        if (this.data.EmployeeTypeID == this.EmployeeDetail[i]["EmployeeTypeID"]) {
          this.toastr.error("Employee category is already exists");
          return
        }
      }
      this.EmployeeDetail[this.EmployeeDetail.length] = {
        "EmployeeTypeID": this.data.EmployeeTypeID, "EmployeeType": empType, "NoOfPermanentEmployee": this.data.NoOfPermanentEmployee
        , "NoOfAdhocEmployee": this.data.NoOfAdhocEmployee, "TotalPermanentSalary": this.data.TotalPermanentSalary, "TotalAdhocSalary": this.data.TotalAdhocSalary
      }
    }
    this.clearEmployeeDetail();
  }

  editEmployeeDetail(i) {
    this.hid_EmployeeDetailID = i;
    this.data.EmployeeTypeID = this.EmployeeDetail[i]["EmployeeTypeID"];
    this.data.NoOfPermanentEmployee = this.EmployeeDetail[i]["NoOfPermanentEmployee"];
    this.data.NoOfAdhocEmployee = this.EmployeeDetail[i]["NoOfAdhocEmployee"];
    this.data.TotalPermanentSalary = this.EmployeeDetail[i]["TotalPermanentSalary"];
    this.data.TotalAdhocSalary = this.EmployeeDetail[i]["TotalAdhocSalary"];
  }

  deleteEmployeeDetail(i) {
    this.EmployeeDetail.splice(parseInt(i), 1);
  }

  clearEmployeeDetail() {
    this.hid_EmployeeDetailID = "-1";
    this.data.EmployeeTypeID = 0;
    this.data.NoOfPermanentEmployee = null;
    this.data.NoOfAdhocEmployee = null;
    this.data.TotalPermanentSalary = null;
    this.data.TotalAdhocSalary = null;
  }

  addInfrastructure() {
    if (this.data.InfrastructureID == undefined || this.data.InfrastructureID == 0) {
      this.toastr.error("Select infrastructure type");
      return
    }
    if (this.data.NoOfInfrastructure == undefined || this.data.NoOfInfrastructure == null || this.data.NoOfInfrastructure == 0) {
      this.toastr.error("Enter No of infrastructure");
      return
    }
    if (this.data.InfrastructureSize == undefined || this.data.InfrastructureSize == null || this.data.InfrastructureSize < 0) {
      this.toastr.error("Enter infrastructure size");
      return
    }
    if (($.trim(this.infraname.toLowerCase()) == "other") && ($.trim(this.data.OtherInfrastructure) == "" || $.trim(this.data.OtherInfrastructure) == undefined)) {
      this.toastr.error("Other infrastructure is required");
      return;
    }

    var InfrastructureType = null
    for (var i = 0; i < this.infrastructures.length; i++) {
      if (this.data.InfrastructureID == this.infrastructures[i]["value"]) {
        InfrastructureType = this.infrastructures[i]["text"];
        break;
      }
    }

    if (parseInt(this.hid_InfrastructureDetailID) >= 0) {
      this.InfrastructureDetail[this.hid_InfrastructureDetailID] = {
        "InfrastructureID": this.data.InfrastructureID, "InfrastructureType": InfrastructureType, "NoOfInfrastructure": this.data.NoOfInfrastructure, "InfrastructureSize": this.data.InfrastructureSize,
        "OtherInfrastructure": this.data.OtherInfrastructure
      }
    }
    else {
      for (var i = 0; i < this.InfrastructureDetail.length; i++) {
        if (this.InfrastructureDetail[i]["InfrastructureType"] != "Other") {
          if (this.data.InfrastructureID == this.InfrastructureDetail[i]["InfrastructureID"]) {
            this.toastr.error("Infrastructure type is already exists");
            return
          }
        }
        if (this.data.InfrastructureID == this.InfrastructureDetail[i]["InfrastructureID"] && (this.data.OtherInfrastructure == $.trim(this.InfrastructureDetail[i]["OtherInfrastructure"]))) {
          this.toastr.error("Other infrastructure is already exists");
          return
        }
      }
      this.InfrastructureDetail[this.InfrastructureDetail.length] = {
        "InfrastructureID": this.data.InfrastructureID, "InfrastructureType": InfrastructureType, "NoOfInfrastructure": this.data.NoOfInfrastructure, "InfrastructureSize": this.data.InfrastructureSize,
        "OtherInfrastructure": this.data.OtherInfrastructure
      }
    }
    this.clearInfrastructure();
  }

  editInfrastructure(i) {
    this.hid_InfrastructureDetailID = i;
    this.data.InfrastructureID = this.InfrastructureDetail[i]["InfrastructureID"];
    this.data.NoOfInfrastructure = this.InfrastructureDetail[i]["NoOfInfrastructure"];
    this.data.InfrastructureSize = this.InfrastructureDetail[i]["InfrastructureSize"];
    this.data.OtherInfrastructure = this.InfrastructureDetail[i]["OtherInfrastructure"];
    setTimeout(() => {
      this.getInfraName();
    }, 1000);
  }

  deleteInfrastructure(i) {
    this.InfrastructureDetail.splice(parseInt(i), 1);
  }

  clearInfrastructure() {
    this.hid_InfrastructureDetailID = "-1";
    this.data.InfrastructureID = 0;
    this.data.NoOfInfrastructure = null;
    this.data.InfrastructureSize = null;
    this.data.OtherInfrastructure = null;
  }

  addTrustee() {
    if (this.data.TrusteeName == undefined || this.data.TrusteeName.trim().length == 0) {
      this.toastr.error("Enter Trustee's Name");
      return
    }
    if (this.data.TrusteeAddress == undefined || this.data.TrusteeAddress.trim().length == 0) {
      this.toastr.error("Enter Trustee Address");
      return
    }
    if (this.data.TrusteeMobileNo == undefined || this.data.TrusteeMobileNo.length != 10) {
      this.toastr.error("Enter valid mobile no");
      return
    }
    if (this.data.TrusteeMailID == undefined) {
      this.toastr.error("Enter email id");
      return
    }
    var pattern = "^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$";
    if (!this.data.TrusteeMailID.match(pattern)) {
      this.toastr.error("Enter valid email id");
      return
    }
    if (parseInt(this.hid_trusteeDetailID) >= 0) {
      this.TrusteeDetail[this.hid_trusteeDetailID] = {
        "TrusteeName": this.data.TrusteeName.trim(), "TrusteeAddress": this.data.TrusteeAddress.trim()
        , "TrusteeMobileNo": this.data.TrusteeMobileNo.trim(), "TrusteeMailID": this.data.TrusteeMailID.trim()
      }
    }
    else {
      for (var i = 0; i < this.TrusteeDetail.length; i++) {
        if (this.data.TrusteeName.trim() == this.TrusteeDetail[i]["TrusteeName"]) {
          this.toastr.error("Trustee's Name already exists");
          return
        }
        if (this.data.TrusteeMobileNo.trim() == this.TrusteeDetail[i]["TrusteeMobileNo"]) {
          this.toastr.error("Mobile No already exists");
          return
        }
        if (this.data.TrusteeMailID.trim() == this.TrusteeDetail[i]["TrusteeMailID"]) {
          this.toastr.error("Trustee's Mail ID already exists");
          return
        }
      }
      this.TrusteeDetail[this.TrusteeDetail.length] = {
        "TrusteeName": this.data.TrusteeName.trim(), "TrusteeAddress": this.data.TrusteeAddress.trim()
        , "TrusteeMobileNo": this.data.TrusteeMobileNo.trim(), "TrusteeMailID": this.data.TrusteeMailID.trim()
      }
    }
    this.clearTrustee();
  }

  editTrustee(i) {
    this.hid_trusteeDetailID = i;
    this.data.TrusteeName = this.TrusteeDetail[i]["TrusteeName"];
    this.data.TrusteeAddress = this.TrusteeDetail[i]["TrusteeAddress"];
    this.data.TrusteeMobileNo = this.TrusteeDetail[i]["TrusteeMobileNo"];
    this.data.TrusteeMailID = this.TrusteeDetail[i]["TrusteeMailID"];
  }

  deleteTrustee(i) {
    this.TrusteeDetail.splice(parseInt(i), 1);
  }

  clearTrustee() {
    this.hid_trusteeDetailID = "-1";
    this.data.TrusteeName = "";
    this.data.TrusteeAddress = "";
    this.data.TrusteeMobileNo = "";
    this.data.TrusteeMailID = "";
  }

  clearRegistrationForm() {
    this.RegistrationForm.resetForm();
    this.TrusteeDetail.length = 0;
    this.TrusteeDetail.length = 0;
  }

  openpopup() {
    this.forgetPasswordForm.resetForm();
    $('#forgetpassModal').modal('show');
  }

  closeForm() {
    $('#registrationModal').modal('hide');
    $('#forgetpassModal').modal('hide');
    $('#checkRequestStatusModal').modal('hide');
    this.RegistrationForm.resetForm();
    this.standardList = [];
  }

  forgetPassword() {
    var val = this.forgetPasswordForm.value['schoolemail'];
    var patternMail = "^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$";
    var patternMobile = "[0-9]{10}";
    if (!val.match(patternMail) && !val.match(patternMobile)) {
      this.toastr.error(" Enter proper detail")
      return
    }
    if (this.forgetPasswordForm.valid) {
      this.spinner.show();
      var data = {
        emailID: this.forgetPasswordForm.value['schoolemail']
      }
      this.service.forgetPasswordSchool(data)
        .subscribe((data1: Response) => {
          this.spinner.hide();
          this.responseData = data1;
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          } else {
            this.toastr.success(this.responseData.message);
            $('#forgetpassModal').modal('hide');
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }

  openpopupRequestStatus() {
    this.RequestStatusForm.resetForm();
    $('#checkRequestStatusModal').modal('show');
  }

  openpopupRegisteration() {
    $("#FrcCode").val('');
    this.data.UDiseNo = null;
    this.data.SchoolName = null;
    this.data.SchoolAddress = null;
    this.data.Pincode = null;
    this.data.SchoolMobileno = null;
    this.data.RegistrationDate = null;
    this.data.SchoolMailID = null;
    this.data.Area = null;
    this.data.City = 0;
    this.data.Trust = null;
    this.data.TrustAddress = null;
    this.data.TrustMobileNo = null;
    this.data.TrustMailID = null;
    this.data.Board = null;
    this.data.Medium = null;
    this.data.Section = null;
    this.data.DocumentDetail.length = 0;
    this.data.TrusteeDetail.length = 0;
    this.data.DocumentDetail.length = 0;
    this.data.InfrastructureDetail.length = 0;
    this.data.EmployeeDetail.length = 0;

    this.TrusteeDetail.length = 0;
    this.data.Office = 0;
    this.data.TypeOfTrust = 0;
    this.data.State = 12;
    this.data.SchoolLocation = 0;
    this.data.SchoolType = 0;
    this.fillCity(0);
    for (var i = 0; i < this.boards.length; i++) {
      var j = $('#chkBoard' + i).prop("checked", false);
    }
    for (var i = 0; i < this.mediums.length; i++) {
      var j = $('#chkmedium' + i).prop("checked", false);
    }
    for (var i = 0; i < this.sections.length; i++) {
      var j = $('#chksection' + i).prop("checked", false);
    }
    this.documentList.length = 0;
    this.InfrastructureDetail.length = 0;
    this.EmployeeDetail.length = 0;
    this.data.InfrastructureID = 0;
    this.data.EmployeeTypeID = 0;

    $("#FSaccount").show();
    $("#FSpersonal").hide();
    $("#FSpayment").hide();
    $("#FSconfirm").hide();
    $("#personal").removeClass("active");
    $("#payment").removeClass("active");
    $("#confirm").removeClass("active");
    this.setProgressBar(1, 4);

    $('#registrationModal').modal('show');

  }

  requestStatus() {
    if (this.RequestStatusForm.valid) {
      var data = {
        HashCode: this.RequestStatusForm.value['requestNo']
      }
      this.spinner.show();
      this.service.checkRequestStatus(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            if (this.responseData.requestStatus == 1) {
              this.toastr.success("Your request is approved");
            }
            else if (this.responseData.requestStatus == 2) {
              this.toastr.error("Your request is rejected by admin");
            }
            else {
              this.toastr.error("Your request is pending");
            }
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }

  Registration(data) {
    this.data.Board = "";
    for (var i = 0; i < this.boards.length; i++) {
      var j = $('#chkBoard' + i).is(":checked");
      if (j == true) {
        if (this.data.Board == "")
          this.data.Board += ",";
        this.data.Board += this.boards[i]["value"] + ",";
      }
    }

    this.data.Medium = "";
    for (var i = 0; i < this.mediums.length; i++) {
      var j = $('#chkmedium' + i).is(":checked");
      if (j == true) {
        if (this.data.Medium == "")
          this.data.Medium += ",";
        this.data.Medium += this.mediums[i]["value"] + ",";
      }
    }
    this.data.InstituteTypeID = "";
    for (var i = 0; i < this.institutetypes.length; i++) {
      var j = $('#chkinstitute' + i).is(":checked");
      if (j == true) {
        if (this.data.InstituteTypeID == "")
          this.data.InstituteTypeID += ",";
        this.data.InstituteTypeID += this.institutetypes[i]["value"] + ",";
      }
    }
    var count = 0;
    this.data.Section = "";
    for (var i = 0; i < this.sections.length; i++) {
      var j = $('#chksection' + i).is(":checked");
      if (j == true) {
        if (this.data.Section == "")
          this.data.Section += ",";
        this.data.Section += this.sections[i]["value"] + ",";
        count = 0;
        for (var p = 0; p < this.standardList.length; p++) {
          if (this.standardList[p]["sectionID"] == this.sections[i]["value"]) {
            var c = $('#chkStd' + p).is(":checked");
            if (c) {
              count++
            }
          }
        }
        if (count == 0) {
          this.toastr.error("Select atleast one standard from selected section");
          return;
        }
      }
    }

    if (this.data.Board == "" || this.data.Medium == "" || this.data.Section == "") {
      return;
    }

    var f = 0;
    for (var i = 0; i < this.sections.length; i++) {
      var j = $('#chksection' + i).is(":checked");
      if (j == true) {
        if (parseInt(this.sections[i]["value"]) > 2) {
          f++;
          break;
        }
      }
    }

    if (f == 0) {
      this.data.AcquiredDate = null;
    }
    if (this.data.Medium == '' || this.data.Medium == undefined || this.data.TypeOfTrust == 0 || this.data.TypeOfTrust == undefined
      || this.data.Section == '' || this.data.Section == undefined || this.data.SchoolLocation == 0
      || this.data.SchoolLocation == undefined || this.data.SchoolType == 0 || this.data.SchoolType == undefined || this.data.State == 0 || this.data.State == undefined
      || this.data.City == undefined || this.data.City == 0) {
      //this.toastr.error('Please fill all details');
      return;
    }
    if (this.TrusteeDetail == undefined || this.TrusteeDetail.length == 0) {
      this.toastr.error("Add atleast one trustee detail");
      return;
    }
    this.data.TrusteeDetail = this.TrusteeDetail;

    if (this.InfrastructureDetail == undefined || this.InfrastructureDetail.length == 0) {
      this.toastr.error("Add atleast one infrastructure detail");
      return;
    }
    this.data.InfrastructureDetail = this.InfrastructureDetail;

    if (this.EmployeeDetail == undefined || this.EmployeeDetail.length == 0) {
      this.toastr.error("Add atleast one employee detail");
      return;
    }

    this.data.EmployeeDetail = this.EmployeeDetail;

    for (var i = 0; i < this.documentList.length; i++) {
      if (this.documentList[i]["Document"] == undefined || this.documentList[i]["Document"] == "") {
        this.toastr.error("Please upload document for all courses.");
        return;
      }
    }
    this.data.DocumentDetail = this.documentList;

    if (this.RegistrationForm.valid) {
      this.spinner.show();
      this.service.saveRegistrationDetails(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.RegistrationForm.resetForm();
            this.closeForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
    // else {
    //   this.toastr.error('Please fill all details');
    //   const invalid = [];
    //   const controls = this.RegistrationForm.controls;
    //   for (const name in controls) {
    //     if (controls[name].invalid) {
    //       invalid.push(name);
    //     }
    //   }
    // }
  }

  previousTab(currTab) {
    if (currTab == "FSpersonal") {
      $("#FSaccount").show();
      $("#FSpersonal").hide();
      $("#personal").removeClass("active");
      this.setProgressBar(1, 4);
    } else if (currTab == "FSpersonal") {
      $("#FSaccount").show();
      $("#FSpersonal").hide();
      $("#payment").removeClass("active");
      this.setProgressBar(2, 4);
    }
    else if (currTab == "FSpayment") {
      $("#FSpersonal").show();
      $("#FSpayment").hide();
      $("#payment").removeClass("active");
      this.setProgressBar(2, 4);
    }
    else if (currTab == "FSconfirm") {
      $("#FSpayment").show();
      $("#FSconfirm").hide();
      $("#confirm").removeClass("active");
      this.setProgressBar(3, 4);
    }
  }

  setProgressBar(curStep, steps) {
    steps = 100 / steps;
    var percent = parseFloat(steps) * curStep;
    //percent = percent.toFixed();
    $(".progress-bar").css("width", percent + "%")
  }

  SaveCollegeInfo() {

    if (this.data.TypeOfTrust == 0 || this.data.TypeOfTrust == undefined || this.data.SchoolLocation == 0 || this.data.SchoolLocation == undefined
      || this.data.SchoolType == 0 || this.data.SchoolType == undefined || this.data.State == 0 || this.data.State == undefined
      || this.data.City == undefined || this.data.City == 0) {
      //this.toastr.error('Please fill all details');
      return;
    }
    if (this.CollegeInfoForm.valid) {
      this.spinner.show();
      this.service.saveCollegeInfo(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.data.HashCode = this.responseData.recordid;
            $("#personal").addClass("active");
            $("#FSaccount").hide();
            $("#FSpersonal").show();
            this.setProgressBar(2, 4);
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }

  SaveEducationInfo() {

    this.data.Board = "";
    for (var i = 0; i < this.boards.length; i++) {
      var j = $('#chkBoard' + i).is(":checked");
      if (j == true) {
        if (this.data.Board == "")
          this.data.Board += ",";
        this.data.Board += this.boards[i]["value"] + ",";
      }
    }

    this.data.Medium = "";
    for (var i = 0; i < this.mediums.length; i++) {
      var j = $('#chkmedium' + i).is(":checked");
      if (j == true) {
        if (this.data.Medium == "")
          this.data.Medium += ",";
        this.data.Medium += this.mediums[i]["value"] + ",";
      }
    }

    this.data.InstituteTypeID = "";
    for (var i = 0; i < this.institutetypes.length; i++) {
      var j = $('#chkinstitute' + i).is(":checked");
      if (j == true) {
        if (this.data.InstituteTypeID == "")
          this.data.InstituteTypeID += ",";
        this.data.InstituteTypeID += this.institutetypes[i]["value"] + ",";
      }
    }

    var count = 0;
    this.data.Section = "";
    for (var i = 0; i < this.sections.length; i++) {
      var j = $('#chksection' + i).is(":checked");
      if (j == true) {
        if (this.data.Section == "")
          this.data.Section += ",";
        this.data.Section += this.sections[i]["value"] + ",";
        count = 0;
        for (var p = 0; p < this.standardList.length; p++) {
          if (this.standardList[p]["sectionID"] == this.sections[i]["value"]) {
            var c = $('#chkStd' + p).is(":checked");
            if (c) {
              count++
            }
          }
        }
        if (count == 0) {
          this.toastr.error("Select atleast one standard from selected section");
          return;
        }
      }
    }

    if (this.data.Board == "" || this.data.Medium == "" || this.data.Section == "") {
      return;
    }

    for (var i = 0; i < this.documentList.length; i++) {
      if (this.documentList[i]["Document"] == undefined || this.documentList[i]["Document"] == "") {
        this.toastr.error("Please upload document for all courses");
        return;
      }
    }
    this.data.DocumentDetail = this.documentList;

    if (this.EducationInfoForm.valid) {
      this.spinner.show();
      this.service.saveEducationInfo(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            $("#payment").addClass("active");
            $("#FSpersonal").hide();
            $("#FSpayment").show();
            this.setProgressBar(3, 4);
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }

  saveOtherInfo() {
    if (this.TrusteeDetail == undefined || this.TrusteeDetail.length == 0) {
      this.toastr.error("Add atleast one trustee detail");
      return;
    }
    this.data.TrusteeDetail = this.TrusteeDetail;

    if (this.EmployeeDetail == undefined || this.EmployeeDetail.length == 0) {
      this.toastr.error("Add atleast one employee detail");
      return;
    }
    this.data.EmployeeDetail = this.EmployeeDetail;

    if (this.OtherInfoForm.valid) {
      this.spinner.show();
      this.service.saveOtherInfo(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            $("#confirm").addClass("active");
            $("#FSpayment").hide();
            $("#FSconfirm").show();
            this.setProgressBar(4, 4);
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }

  saveInfrastructureInfo() {
    if (this.InfrastructureDetail == undefined || this.InfrastructureDetail.length == 0) {
      this.toastr.error("Add atleast one infrastructure detail");
      return;
    }

    this.data.InfrastructureDetail = this.InfrastructureDetail;

    if (this.OtherInfoForm.valid) {
      this.spinner.show();
      this.service.saveInfrastructureInfo(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.closeForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }

  ShowRegistrationDetail() {
    var FrcCode = $("#FrcCode").val();
    if (FrcCode != "")
      this.fillRegistrationRequestDetail(FrcCode);
    else {
      this.toastr.error("Enter ACI code");
    }
  }

  fillRegistrationDetailByCollegeCode() {
    this.spinner.show();
    var Requestdata = {
      collegeCode: this.data.UDiseNo
    }
    this.service.fillRegistrationDetailByCollegeCode(Requestdata)
      .subscribe((data: Response) => {
        this.spinner.hide();
        this.responseData = data;
        if (this.responseData.status == true) {
          this.data.SchoolName = this.responseData.SchoolName
          this.data.SchoolAddress = this.responseData.SchoolAddress
          this.data.SchoolMobileno = this.responseData.SchoolMobileno
          this.data.SchoolMailID = this.responseData.SchoolMailID
          this.data.SchoolLocation = this.responseData.SchoolLocation
          this.data.SchoolType = this.responseData.SchoolType
          this.data.Pincode = this.responseData.Pincode
          this.data.Trust = this.responseData.TrustName
          this.data.State = this.responseData.StateID
          this.fillCity(this.responseData.CityID);
          $("#btnsavepersonal").css("display", "block");
        }
        else {
          this.data.SchoolName = null
          this.data.SchoolAddress = null
          this.data.SchoolMobileno = null
          this.data.SchoolMailID = null
          this.data.SchoolLocation = 0
          this.data.SchoolType = 0
          this.data.Pincode = null
          this.data.City = 0
          this.data.State = 0
          this.data.Trust = null
          if (this.data.UDiseNo != undefined && this.data.UDiseNo.toString().trim().length > 0)
            this.toastr.error("Invalid college code");
          $('#btnsavepersonal').css("display", "none");
        }

      })
  }

  checkAllCourse() {
    var c = $("#checkAllCourse").prop("checked");
    this.documentList = [];
    if (c) {
      for (var i = 0; i < this.standardList.length; i++) {
        $("#chkStd" + i).prop("checked", c);
        this.manageRegDoc(i, this.standardList[i]["text"], this.standardList[i]["MediumID"],
          this.standardList[i]["sectionID"], this.standardList[i]["value"])
      }
    } else {
      for (var i = 0; i < this.standardList.length; i++) {
        $("#chkStd" + i).prop("checked", c);
      }
    }
  }
}
